<div class="content-wrapper">
  <div class="page-title-box">
    <h4>Payment List</h4>
  </div>

  <div class="card card-nobody">
    <div class="card-body">
      <div class="table-wrapper">
        <app-dp-list (pageEvent)="onPageEvent($event)"
                     [pagedResponse]="pagedResponse">
          <table class="table table-list align-middle table-nowrap table-check">
            <thead>
            <tr>
              <th>
                <div class="checkbox c-checkbox">
                  <label class="mb-0">
                    <input (change)="selectAll()" [checked]="isAllChecked" class="form-check-input" type="checkbox"/>
                  </label>
                </div>
              </th>
              <th *ngIf="isAdmin">Store</th>
              <th>Model code</th>
              <th>Serial No</th>
              <th>IEMI</th>
              <th class="text-right">Repair Cost</th>
              <th class="text-right">Tax</th>
              <th class="text-right">Total Cost</th>
              <th>Requester</th>
              <th>CreateDate</th>
              <th class="text-center">Customer Pay</th>
            </tr>
            </thead>
            <tbody>
            <tr (click)="changeCheckBoxStatus($event, ticket)"
                *ngFor="let ticket of tickets; let i = index">
              <td class="td-checkbox">
                <div class="checkbox c-checkbox">
                  <label class="mb-0">
                    <input [checked]="ticket.isChecked" [disabled]="ticket.customerPayment === 'SENT'"
                           class="form-check-input"
                           type="checkbox"/>
                  </label>
                </div>
              </td>
              <td *ngIf="isAdmin">{{ ticket.dealerStore?.name }}</td>
              <td>{{ ticket.modelCode }}</td>
              <td>{{ ticket.serialNo }}</td>
              <td>{{ ticket.imei }}</td>
              <td class="text-right">{{ repairCost(ticket.sc4u?.pricing?.pricing, 'price')| currency }}</td>
              <td class="text-right">{{ repairCost(ticket.sc4u?.pricing?.pricing, 'tax')| currency }}</td>
              <!--              <td class="text-right">{{ticket.sc4u?.pricing?.amount || 0 | currency}}</td>-->
              <td class="text-right">{{ ticket.cardHoldInfo?.amount || 0 | currency }}</td>
              <td>{{ ticket.email }}</td>
              <td>{{ ticket.postingDate | hqDate }}</td>
              <td class="text-center">
                <div *ngIf="!ticket.isChecked">
                  <ng-container *ngIf="ticket.customerPayment === 'SENT'; else isNull">
                    <div class="d-flex justify-content-center">
                      <button (click)="resend($event, ticket)" class="btn btn-dark button-small btn-cursor mr-12px"
                              type="button">Resend
                      </button>
                      <button (click)="sendCancel($event, ticket)" class="btn btn-outline-dark button-small btn-cursor"
                              type="button">Cancel
                      </button>
                    </div>
                  </ng-container>
                  <ng-template #isNull>
                    <button (click)="send($event, ticket)" class="btn btn-dark button-small btn-cursor" type="button">
                      Send
                      Payment Link
                    </button>
                  </ng-template>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </app-dp-list>

        <app-dp-detail class="pt-0" style="width: 800px !important;">
          <app-create-card-holding (reload)="showList()"></app-create-card-holding>
        </app-dp-detail>
      </div>
    </div>
  </div>

</div>

